import { useEffect, useState } from "react";
import { Button, CircularProgress, InputLabel, Switch, TextField } from "@mui/material";
import DialogC from "../../../components/Dialog";
import { useForm } from 'react-hook-form'
import { yupResolver } from "@hookform/resolvers/yup";
import { ValidationSchema } from "../services/SchemaValidation"
import { ValidateErrorMessage } from "../../../components/ValidateErrorMessage";
import { useMutation } from 'react-query'
import { editPropertyAmenity } from "../../../services/api/PropertyAmenity";

export default function Edit({ open, setOpen, amenity, reportAction }) {
  const [isLoading, setIsLoading] = useState(false)
  const [dataAmenity, setDataAmenity] = useState({})
  let { reset, handleSubmit, register, formState: { errors }, setValue }  = useForm({ 
    resolver: yupResolver(ValidationSchema)
  })

  useEffect(() => {
    if(open) {
      setDataAmenity(amenity)
      setValue("name", amenity.name)
      setValue("icon", amenity.icon)
      setValue("description", amenity.description)
      setValue("active", amenity.active)
    }
  }, [open])

  const mutation = useMutation(editPropertyAmenity, {
    onSuccess: (data) => {
      setIsLoading(false)
      if(data.status === "error") { reportAction('edit', false, { message: 'Error al editar los datos'}, false)
      } else { reportAction('edit', false, { }, true) }
    }
  })

  const handleEdit = (params) => { 
    console.log("prueba", params)
    console.log("id", dataAmenity._id)
    setIsLoading(true)
    mutation.mutate({id: dataAmenity._id, params: params})
  }

  const handleClose = () => { reset(); setDataAmenity({}); setOpen(false) }

  const handleOnChangeData = (event) => { 
    setDataAmenity({...dataAmenity, [event.target.name]: event.target.value}) 
  }

  const handleChangeActive = (event) => {
    setDataAmenity({...dataAmenity, active: !dataAmenity.active}) 
  }

  const Actions = () => (<>
    { !isLoading ? <>
      <Button onClick={handleClose}>Cancel</Button>
      <Button variant="contained" color="info" onClick={handleSubmit(handleEdit)}>Editar</Button>
      </> : <CircularProgress /> }
  </>)
  //https://cdn-icons-png.flaticon.com/512/6133/6133429.png
  //https://cloudinary.com/pricing
  return (
    <DialogC open={open} title={`Editar - ${amenity.name}`} actions={<Actions />}>
      <>
        <InputLabel htmlFor='name' required style={{ fontSize: 14 }}>Nombre</InputLabel>
        <TextField id='name' fullWidth margin="dense" type="text" name='name'
          value={dataAmenity.name || ""}
          {...register(`name`)} 
          error={errors.name ? true: false}
          onChange={handleOnChangeData} />
        <ValidateErrorMessage message={errors.name?.message} />
        <br />
        <InputLabel htmlFor='description' style={{ fontSize: 14 }}>Descripción</InputLabel>
        <TextField id='description' fullWidth margin="dense" type="text" name='description'
          multiline
          maxRows={4}
          value={dataAmenity.description || ""}
          {...register(`description`)} 
          error={errors.description ? true: false}
          onChange={handleOnChangeData} />
        <ValidateErrorMessage message={errors.description?.message} />
        <br />
        <div style={{ display: "grid", gridTemplateColumns: "50% 50%"}}>
          <div style={{ textAlign: "center" }}>
            <img src={dataAmenity.icon || "/images/picture_empty.png"} style={{ width: "50%" }}/>
          </div>
          <div>
          <InputLabel htmlFor='icon' style={{ fontSize: 14 }}>Icono</InputLabel>
          <TextField id='icon' fullWidth margin="dense" type="text" name='icon'
            value={dataAmenity.icon || ""}
            {...register(`icon`)} 
            error={errors.icon ? true: false}
            onChange={handleOnChangeData} />
          <ValidateErrorMessage message={errors.icon?.message} />
          </div>
        </div>
        <br />
        <InputLabel htmlFor='description' required style={{ fontSize: 14 }}>Activo?</InputLabel>
        <Switch edge="end" inputProps={{ 'aria-labelledby': `switch-list-label-active` }}
          onClick={handleChangeActive}
          checked={dataAmenity.active || false} 
          {...register(`active`)} 
        />
      </>
    </DialogC>
  )
}